import { render, staticRenderFns } from "./word-cloud-container-dark-blue.vue?vue&type=template&id=d0457c8e&scoped=true&"
import script from "./word-cloud-container-dark-blue.vue?vue&type=script&lang=js&"
export * from "./word-cloud-container-dark-blue.vue?vue&type=script&lang=js&"
import style0 from "./word-cloud-container-dark-blue.vue?vue&type=style&index=0&id=d0457c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0457c8e",
  null
  
)

component.options.__file = "word-cloud-container-dark-blue.vue"
export default component.exports